import React, { useState, useEffect } from 'react';
import './WomensSection.css';

const WomensSection = ({ 
    title = {
        EN: 'Womens',
        KU: 'خانمانی ڕۆشنگەر',
        AR: 'النساء المستنيرات',
        TR: 'Aydın Kadınlar'
    },
    images = [],
    sectionId = 'womens',
    className = ''
}) => {
    const [currentLang, setCurrentLang] = useState(() => {
        return localStorage.getItem('selectedLanguage') || 'KU';
    });

    useEffect(() => {
        const handleLanguageChange = (event) => {
            setCurrentLang(event.detail);
        };
        window.addEventListener('languageChange', handleLanguageChange);
        return () => window.removeEventListener('languageChange', handleLanguageChange);
    }, []);

    // Safely extract title string from translation object
    let displayTitle = '';
    if (typeof title === 'object' && title !== null) {
      displayTitle = title[currentLang] || title.EN || title.KU || title.AR || title.TR || '';
    } else {
      displayTitle = title || '';
    }

    return (
        <section className={`section womens-section ${className}`} id={sectionId}>
            <div className="container">
                {displayTitle && (
                    <h2 className="section-title">
                        {displayTitle}
                    </h2>
                )}

                {images && images.length > 0 && (
                    <div className="womens-grid">
                        {images.map((img, index) => {
                            // Handle different image formats: string URL, object with src/url property
                            const imgSrc = typeof img === 'string' 
                                ? img 
                                : (img.src || img.url || img);
                            const imgAlt = typeof img === 'object' && img.alt 
                                ? img.alt 
                                : `Image ${index + 1}`;
                            const imgId = typeof img === 'object' && img.id 
                                ? img.id 
                                : index;
                            
                            return (
                                <div key={imgId} className="womens-card glass">
                                    <div className="womens-image-wrapper">
                                        <img 
                                            src={imgSrc} 
                                            alt={imgAlt} 
                                            loading="lazy" 
                                        />
                                    </div>
                                    <div className="womens-card-overlay">
                                        <div className="womens-card-icon">✨</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

export default WomensSection;
